import React from "react";

const Java_Private = () => {
  return (
    <div>
      <h1>Java Private</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Private in Java.</p>
    </div>
  );
};

export default Java_Private;
